import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { login } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) { nav("/login", { replace: true }); return; }
    api.post("/auth/google/session", { session_id: sid })
      .then(({ data }) => {
        login(data.token, data.user);
        window.history.replaceState(null, "", window.location.pathname);
        nav(data.user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      })
      .catch((err) => {
        toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Google sign-in failed");
        nav("/login", { replace: true });
      });
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto" />
        <p className="mt-4 text-slate-500">Signing you in…</p>
      </div>
    </div>
  );
}
